import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Observable, of} from 'rxjs';
import {FacadeService} from '../../service/facade/facade.service';
import {catchError, map} from 'rxjs/operators';
import {User} from 'src/app/users/shared/model/user.model';

@Injectable()
export class UserUuidResolver implements Resolve<Observable<User>> {
  constructor(private facadeService: FacadeService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<User> {
    const uuid = route.queryParams['uuid'];
    return this.facadeService.getUserByUuid(uuid).pipe(
      map((data) => data),
      catchError(error => {
        return of({error: error});
      })
    );
  }
}
